module.exports = __webpack_public_path__ + "static/media/soal1.cc091bdd.png";